module.exports = __webpack_public_path__ + "img/四大承诺@2x.0dfd6b8e.png";